import { OrderAheadController } from './lib';

export default OrderAheadController;
export { useOrderAheadNavigationOnClick } from './lib';
